module.exports = __webpack_public_path__ + "img/cert33.09f967cb.png";